module.exports = __webpack_public_path__ + "static/media/new-capa3.4539e273.png";